export default {"src":"/_next/static/media/tablet-minor.4b9f7070.svg","height":75,"width":80};